import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import Lightbox from 'react-image-lightbox'
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Form, Input, Label, Media, Row, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import { TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS, TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones"
import _valid from "../../validations"
import Select from 'react-select'
import Resizer from "react-image-file-resizer";

const PRIORIDAD_NORMAL = 1;
const PRIORIDAD_EMERGENCIA = 3;

const prioridadEmergenciaSeleccionada = (registro = {}) =>
    Number(registro.check_prioridad) === 1 || Number(registro.prioridad) === PRIORIDAD_EMERGENCIA;

const normalizarPrioridadRegistro = (registro = {}) => {
    const prioridadEmergencia = prioridadEmergenciaSeleccionada(registro);
    const prioridad = registro.prioridad === undefined || registro.prioridad === null ? PRIORIDAD_NORMAL : registro.prioridad;

    return {
        ...registro,
        prioridad: prioridadEmergencia ? PRIORIDAD_EMERGENCIA : prioridad,
        check_prioridad: prioridadEmergencia ? 1 : 0
    };
};

export default class SolicitudFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);
        props = _valid(props, props.props) ? props.props : props;

        this.pathnameAnterior = props.location.pathnameAnterior

        const registroInicial = _valid(props) && _valid(props.location) && _valid(props.location.registro) ? props.location.registro : {
            titulo: "",
            descripcion: "",
            img_nueva_solicitud: undefined,
            estado: 0,
            prioridad: PRIORIDAD_NORMAL,
            check_prioridad: 0,
            solicitar_a: undefined,
            lugar_ubicacion: undefined,
            //tipo_solicitud: undefined
        };

        this.state = {
            registro: normalizarPrioridadRegistro(registroInicial),
            imgNuevaSolicitudBase64: null,
            verImagenEnGrande: false,

            colapsar: true,
            colapsarDepartamentoArea: true,
            colapsarUbicacion: true,
            colapsarTipoSolicitud: true,

            historialGuardado: false,

            departamentoAreas: undefined,
            ubicaciones: undefined,
            tipoSolicitudes: [],

            camposRequeridos: [],
            modalAbierto: false,
            isButtonDisabled: true,
        };
        this.fileInput = React.createRef();
        this.colapsar = this.colapsar.bind(this);
        this.actualizarImagen = this.actualizarImagen.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.setUbicacion = this.setUbicacion.bind(this);
        this.setDepartamento = this.setDepartamento.bind(this);
        this.obtenerTipoSolicitud = this.obtenerTipoSolicitud.bind(this);
    }

    componentDidMount() {
        const { registro } = this.state;
        let idDepartamentoArea = null;
        for (const key in registro) {
            if (key === 'departamento' || key === 'solicitar_a') {
                idDepartamentoArea = registro[key];
            }
        }

        //this.obtenerPadres();
        this.obtenerDepartamentos();
        this.obtenerTipoSolicitud(idDepartamentoArea);
        this.obtenerUbicacion();
        this.cargarLocalStorage();
        if (_valid(registro) && _valid(registro.id)) {
            this.apiRest.getWithFiles('/solicitud/' + registro.id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ registro: normalizarPrioridadRegistro(resultado.data) });
                    if (_valid(resultado.imgNuevaSolicitudBase64)) {
                        this.setState({ imgNuevaSolicitudBase64: resultado.imgNuevaSolicitudBase64 })
                    }
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    obtenerPadres() {
        this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ ubicaciones: this.formatoSelect(resultado) });
            } else {
                this.props.props.history.replace('/Timeout');
                //toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerUbicacion() {
        /*if (departamentosArea == 41) { */
            this.apiRest.get('/ubicacion_dimasa').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ ubicaciones: this.formatoSelect(resultado) });
                } else {
                    this.props.props.history.replace('/Timeout');
                }
            })
        /*} else {
            this.apiRest.get('/ubicacion').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ ubicaciones: this.formatoSelect(resultado) });
                } else {
                    this.props.props.history.replace('/Timeout');
                }
            })
        }*/
    }

    obtenerDepartamentos() { 
        this.apiRest.get('/departamentosInSolicitud').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentoAreas: this.formatoSelector(resultado) });
            } else {
                this.props.props.history.replace('/Timeout');
                //toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerTipoSolicitud(idDepartamentoArea) {
        /*if (_valid(idDepartamentoArea)) {
            this.apiRest.get('/tipoSolicitudPorDepartamentoArea/' + idDepartamentoArea).then(resultado => {
                if (resultado.exitoso) {
                    this.setState(estadoAnterior => ({
                        tipoSolicitudes: resultado.data,
                        registro: { ...estadoAnterior.registro, solicitar_a: idDepartamentoArea }
                    }));
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }*/
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, solicitar_a: idDepartamentoArea }
        }));
    }

    cargarLocalStorage(){
        /*const nueva_solicitud_depto = JSON.parse(localStorage.getItem("nueva_solicitud_depto"));
        if(nueva_solicitud_depto){
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['solicitar_a']: nueva_solicitud_depto.value }
            }));
            this.setState({
                solicitar_a: nueva_solicitud_depto
            });
            
            //this.obtenerUbicacion(nueva_solicitud_depto.value);

            const nueva_solicitud_ubicacion = JSON.parse(localStorage.getItem("nueva_solicitud_ubicacion"));
            if(nueva_solicitud_ubicacion){
                this.setState(estadoAnterior => ({
                    registro: { ...estadoAnterior.registro, ['lugar_ubicacion']: nueva_solicitud_ubicacion.value }
                }));
                this.setState({
                    lugar_ubicacion: nueva_solicitud_ubicacion
                });
            }
        } else {
            this.obtenerUbicacion();
        }*/
        localStorage.removeItem("nueva_solicitud_ubicacion");
        
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    handleChange = ({ target: { checked } }) => {
        const prioridad = checked ? PRIORIDAD_EMERGENCIA : PRIORIDAD_NORMAL;
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, prioridad, check_prioridad: checked ? 1 : 0 }
        }));
    }

    setUbicacion = (target) => {
        if (_valid(target)) {
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['lugar_ubicacion']: target.value }
            }));
            this.setState({
                lugar_ubicacion: target
            });
            localStorage.setItem("nueva_solicitud_ubicacion", JSON.stringify(target));
        } else {
            this.setState({
                lugar_ubicacion: null
            });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['lugar_ubicacion']: undefined }
            }));
        }
    }

    setDepartamento = (target) => {
        if (_valid(target)) {
            this.obtenerTipoSolicitud(target.value);
            this.setState({
                solicitar_a: target
            });
            localStorage.setItem("nueva_solicitud_depto", JSON.stringify(target));
            localStorage.removeItem("nueva_solicitud_ubicacion");
            //this.setState({ ubicaciones: null, lugar_ubicacion: null });
            //this.obtenerUbicacion(target.value);
        } else {
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['solicitar_a']: undefined }
            }));
            this.setState({
                solicitar_a: null
            });
            this.setState({ tipoSolicitudes: [] })
        }
    }

    handleImage = (image, name) => {
        
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: image }
        }));
        console.log("File convertido", image)
        console.log("File convertido", name)
    };

    

    actualizarImagen = ({ target: { name, files } }) => {
        const file = files[0];
        if (file) {
            console.log("File received", file);
            try {
              Resizer.imageFileResizer(
                file,
                1500,
                1500,
                "JPEG",
                90,
                0,
                (blob) => {
                    const newFile = new File([blob], file.name, { type: blob.type });
                    this.handleImage(newFile, name);
                },
                "blob",
                400,
                400
              );
            } catch (err) {
              console.log(err);
            }
          }
        ;
    }

    actualizarValorDepartamento = ({ target: { value } }) => {
        this.obtenerTipoSolicitud(value);
    }

    enviarCorreo = id => {
        const filtro = { "envioAColaboradoresDeUnArea": id };
        this.apiRest.post('/enviarMultiplesCorreosPorParametrosSolicitud', filtro).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado a todos los colaboradores de la area seleccionada.');
            } else if (resultado.response.status === 400) {
                console.log('El departamento no tiene colaboradores asociados.');
                //toastr.error('El departamento no tiene colaboradores asociados.');
            } else {
                console.log('Ocurrió un error. No se ha enviado el correo, por favor intenta nuevamente.');
                //toastr.error('Ocurrió un error. No se ha enviado el correo, por favor intenta nuevamente.');
            }
        });
    }

    enviarTelegram(id) {
        this.apiRest.get('/enviarTelegramSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Telegram enviado exitosamente!');
            } else {
                console.log('Vaya! Ha ocurrido un error al enviar telegram, por favor intenta nuevamente.');
            }
        });
    }

    whatsappNuevaSolicitud(id) {
        this.apiRest.get('/whatsappNuevaSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Whatsapp enviado exitosamente!');
            } else {
                console.log('Vaya! Ha ocurrido un error al enviar whatsapp, por favor intenta nuevamente.');
            }
        });
    }

    enviarOdoo(id) {
        this.apiRest.get('/enviarOdooSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Enviado a Odoo exitosamente!');
            } else {
                console.log('Vaya! Ha ocurrido un error al enviar a odoo, por favor intenta nuevamente.');
            }
        });
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoSelector = valores => valores.data.map(i => ({ value: i.id, label: i.label.split("/")[0] }));

    almacenarRegistro = async () => {
        this.setState({ isButtonDisabled: true });
        const registro = normalizarPrioridadRegistro(this.state.registro);
        let datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_nueva_solicitud", "img_calificacion", "img_solicitud_tarea_trabajada");
        datosFormulario.append("solicitante", this.apiRest.getLS('du').colaborador.id);

        if(this.verificarCamposSolicitud(registro)){
            if (_valid(registro.id)) {
                await this.apiRest.putFiles('/solicitudActualizar/' + registro.id, datosFormulario).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        if (_valid(resultado.imgNuevaSolicitudBase64)) {
                            this.setState({ imgNuevaSolicitudBase64: resultado.imgNuevaSolicitudBase64 });
                        }
    
                        this.props.props.history.replace(this.pathnameAnterior);
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                await this.apiRest.postFiles('/solicitud', datosFormulario).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ registro: resultado.data });
                        if (_valid(resultado.imgNuevaSolicitudBase64)) {
                            this.setState({ imgNuevaSolicitudBase64: resultado.imgNuevaSolicitudBase64 });
                        }
                        //this.enviarCorreo(resultado.data.id);
                        //this.enviarTelegram(resultado.data.id);
                        this.whatsappNuevaSolicitud(resultado.data.id);
                        //this.enviarOdoo(resultado.data.id); //Allan C: para odoo 16 se creara y se realizara la asignacion
                        this.setState({ modalAbierto: true });
                        //this.props.props.history.replace(this.pathnameAnterior);
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
        setTimeout(() => this.setState({ isButtonDisabled: false }), 5000);
    }

    verificarCamposSolicitud = (solicitud) => {
        let valido = true;

        /*if(!_valid(solicitud.titulo)){
            toastr.error('Debe Ingresar un Titulo.');
            valido = false;
        }*/
        if(!_valid(solicitud.solicitar_a)){
            toastr.error('Debe Seleccionar un Departamento.');
            valido = false;
        }
        /*if(!_valid(solicitud.tipo_solicitud)){
            toastr.error('Debe Seleccionar un Tipo de Solicitud.');
            valido = false;
        }*/
        if(!_valid(solicitud.lugar_ubicacion)){
            toastr.error('Debe Seleccionar un lugar de ubicación.');
            valido = false;
        }
        if(!_valid(solicitud.descripcion)){
            toastr.error('Debe Ingresar una Descripción.');
            valido = false;
        }
        if(solicitud.solicitar_a == 41 || solicitud.solicitar_a == 36) { /* Foto obligatoria para Mantenimiento y Mercadeo */
            if(!_valid(solicitud.img_nueva_solicitud)){
                toastr.error('Debe subir una foto.');
                valido = false;
            }
        }        
        return valido;
    }

    datosRegistroValidos() {
        const { registro, camposRequeridos } = this.state;

        /*if (!_valid(registro.titulo)) {
            camposRequeridos.push("Título");
        }*/
        if (!_valid(registro.descripcion)) {
            camposRequeridos.push("Descripción");
        }
        if (!_valid(registro.img_nueva_solicitud)) {
            camposRequeridos.push("Imagen");
        }
        if (!_valid(registro.solicitar_a)) {
            camposRequeridos.push("Departamento a solicitar");
        }
        if (!_valid(registro.lugar_ubicacion)) {
            camposRequeridos.push("Tu ubicación");
        }
        /*if (!_valid(registro.tipo_solicitud)) {
            camposRequeridos.push("El tipo de solicitud");
        }*/
        if (_valid(camposRequeridos)) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);
            return false
        }
        return true;
    }

    solicitudCreada = () => {
        this.setState({ modalAbierto: false });
        this.setState({ registro: {} });
        this.props.props.history.replace(_valid(this.pathnameAnterior) ? this.pathnameAnterior : '/solicitudNueva');
    }

    borrarDatos = () => {
        this.setState({ modalAbierto: false });

        const { lugar_ubicacion, solicitar_a } = this.state;

        this.setState({
            registro: {
                titulo: "",
                descripcion: "",
                img_nueva_solicitud: undefined,
                estado: 0,
                prioridad: 1,
                check_prioridad: 0,
                solicitar_a: solicitar_a.value,
                lugar_ubicacion: lugar_ubicacion.value
                //tipo_solicitud: 0
            }
        })

        this.fileInput.current.value = null;

        this.cargarLocalStorage();

        this.setState({ imgNuevaSolicitudBase64: null });

    }

    render() {
        const { modalAbierto, solicitar_a, lugar_ubicacion, imgNuevaSolicitudBase64, verImagenEnGrande, registro, colapsar, camposRequeridos, departamentoAreas, ubicaciones, tipoSolicitudes } = this.state;
        return (
            <div>
                <React.Fragment>
                    <Card>
                        <CardBody>
                            <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                <div className="p-4">
                                    <Media className="d-flex align-items-center">
                                        <div className="me-3">
                                            <i className="uil uil-receipt text-primary h2"></i>
                                        </div>
                                        <div className="flex-1 overflow-hidden">
                                            <h5 className="font-size-16 mb-1">Solicitud</h5>
                                            <p className="text-muted font-size-15 text-truncate mb-0">En caso de Emergencia debe seleccionarlo en el campo de Prioridad.</p>
                                        </div>
                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                    </Media>
                                </div>
                            </Link>
                            <Collapse isOpen={colapsar}>
                                <div className="p-4 border-top">
                                    <Form>
                                        <div>
                                            <Row>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="descripcion" className="form-label">
                                                            Buen dia, mi solicitud es
                                                        </Label>
                                                        <Input
                                                            value={registro.descripcion}
                                                            onChange={this.actualizarValores}
                                                            name="descripcion"
                                                            type="textarea"
                                                            placeholder=""
                                                            maxLength={590}
                                                            rows="4"
                                                        />
                                                    </div>
                                                </Col>
                                                {/*<Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label
                                                            htmlFor="titulo"
                                                            className="form-label"
                                                        >
                                                            Título
                                                        </Label>
                                                        <Input
                                                            value={registro.titulo}
                                                            onChange={this.actualizarValores}
                                                            name="titulo"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Ingresa el título"
                                                        />
                                                    </div>
                                                </Col>*/}
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="solicitar_a" className="form-label">
                                                            Solicitar a (departamento a quien va dirigido)
                                                        </Label>
                                                        <Select
                                                            name="solicitar_a"
                                                            options={departamentoAreas}
                                                            value={solicitar_a}
                                                            onChange={this.setDepartamento}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            placeholder="Seleccionar"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            noOptionsMessage={() => "No hay más opciones"}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="lugar_ubicacion" className="form-label">
                                                            Lugar (tu ubicación)
                                                        </Label>
                                                        <Select
                                                            name="lugar_ubicacion"
                                                            options={ubicaciones}
                                                            value={lugar_ubicacion}
                                                            onChange={this.setUbicacion}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            placeholder="Seleccionar"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            noOptionsMessage={() => "No hay más opciones"}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {/*<Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="tipo_solicitud" className="form-label">
                                                            Tipo Solicitud
                                                        </Label>
                                                        <select
                                                            value={registro.tipo_solicitud}
                                                            onChange={this.actualizarValores}
                                                            name="tipo_solicitud"
                                                            className="form-control"
                                                        >
                                                            <option value="0">Seleccionar</option>
                                                            {tipoSolicitudes.map(item => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                        </select>
                                                    </div>
                                                </Col>*/}
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="prioridad" className="form-label">
                                                            Emergencia
                                                        </Label>
                                                        <Input
                                                            type="checkbox"
                                                            id="prioridad"
                                                            name="check_prioridad"
                                                            checked={prioridadEmergenciaSeleccionada(registro)}
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                        />
                                                    </div>
                                                </Col>
                                                {/*<Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="estado" className="form-label">
                                                            Estado
                                                        </Label>
                                                        <select
                                                            value={registro.estado}
                                                            onChange={this.actualizarValores}
                                                            name="estado"
                                                            className="form-control"
                                                            disabled={true}
                                                        >
                                                            <option value="0">No asignado</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>*/}                                                
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="img_nueva_solicitud" className="form-label">
                                                            Subir Foto
                                                        </Label>
                                                        <input
                                                            name="img_nueva_solicitud"
                                                            className="form-control"
                                                            type="file"
                                                            onChange={this.actualizarImagen}
                                                            accept="image/png, image/jpeg"
                                                            ref={this.fileInput}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="img_nueva_solicitud" className="form-label">
                                                            Foto
                                                        </Label>
                                                        <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                            {
                                                                (imgNuevaSolicitudBase64 !== null) && <img width="100%" src={`data:image/jpeg;base64,${imgNuevaSolicitudBase64}`} alt="solicitud" />
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        &nbsp;
                                        <Row>
                                            {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                        </Row>
                                    </Form>
                                </div>
                                <Row>
                                    <Col lg={12} className="text-end">
                                        <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.props.history.replace(this.pathnameAnterior) }}>
                                            <MDBIcon icon="fas fa-arrow-left" />{' '}
                                            Regresar
                                        </MDBBtn>
                                        {' '}
                                        <MDBBtn className="waves-effect" color="success" onClick={this.almacenarRegistro} disabled={this.state.isButtonDisabled}>
                                            <MDBIcon icon="fas fa-user-check" /> {' '}
                                            Listo
                                        </MDBBtn>
                                    </Col>
                                </Row>
                            </Collapse>
                        </CardBody>
                    </Card>
                    {/* MODAL */}
                    <Modal isOpen={modalAbierto} size="mm">
                        <ModalHeader>
                            Solicitud Enviada
                        </ModalHeader>
                        <ModalBody>
                            Número de Solicitud: {_valid(registro.id) && registro.id ? registro.id : 'N/A'}
                        </ModalBody>
                        <ModalFooter className="text-center">
                            <Row>
                                <Col>
                                    <MDBBtn className="waves-effect" color="warning" onClick={() => this.borrarDatos()}>
                                        <MDBIcon icon="fas fa-plus-circle" /> {' '}
                                        Nueva Solicitud
                                    </MDBBtn>
                                </Col>
                                <Col>
                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.solicitudCreada()}>
                                        <MDBIcon icon="fas fa-thumbs-up" /> {' '}
                                        Salir
                                    </MDBBtn>
                                </Col>
                            </Row>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>
                {verImagenEnGrande && <Lightbox mainSrc={`data:image/jpeg;base64,${imgNuevaSolicitudBase64}`} onCloseRequest={() => this.setState({ verImagenEnGrande: false })} />}
            </div>
        );
    }
}
